import { render, staticRenderFns } from "./DashboardStatsItem.vue?vue&type=template&id=079b61cd"
import script from "./DashboardStatsItem.vue?vue&type=script&lang=js"
export * from "./DashboardStatsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079b61cd')) {
      api.createRecord('079b61cd', component.options)
    } else {
      api.reload('079b61cd', component.options)
    }
    module.hot.accept("./DashboardStatsItem.vue?vue&type=template&id=079b61cd", function () {
      api.rerender('079b61cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/partials/DashboardStatsItem.vue"
export default component.exports